import * as React from 'react';
import { MouseEventHandler } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { ProfileDocumentFragment, TravellerFieldEnum, TravellerProfileLightFragment } from '@websky/graphql';

import css from './companionItem.module.css';
import { getTravellerFullName, getUserValue } from '../../../../../utils';
import { NationalityKeyLabelMap } from '@entities/passengers';
import { getDateValue } from './utils';

interface Props {
	document: ProfileDocumentFragment;
	companion: TravellerProfileLightFragment;
	onClick: MouseEventHandler<HTMLDivElement>;
	nationalities: NationalityKeyLabelMap;
}

const CompanionItem: React.FC<Props> = props => {
	const { document, onClick, nationalities } = props;

	const { t } = useTranslation('Passenger');

	const birthDate = getDateValue(document, TravellerFieldEnum.BirthDate);
	const docExpiryDate = getDateValue(document, TravellerFieldEnum.DocExpiryDate);

	// Extract document information
	const docType = getUserValue(document, TravellerFieldEnum.DocType);
	const docNumber = getUserValue(document, TravellerFieldEnum.DocNumber);

	const citizenship = getUserValue(document, TravellerFieldEnum.Citizenship);

	// Check if document information is available
	const hasDocument = Boolean(docType && docNumber);
	const hasExpiryDate = Boolean(docExpiryDate);

	const fullName = getTravellerFullName(document);

	return (
		<div className={css.root} onClick={onClick}>
			<div className={css.row}>
				<span className={css.name}>{fullName}</span>
				{birthDate && <span>{birthDate}</span>}
			</div>

			{hasDocument && (
				<div className={cn(css.row, css.doc)}>
					<span>{t(docType)}:</span>
					<span>{docNumber}</span>
				</div>
			)}

			{nationalities.has(citizenship) && (
				<div className={cn(css.row, css.doc)}>
					<span>{t('Citizenship')}:</span>
					<span>{nationalities.get(citizenship)}</span>
				</div>
			)}

			{hasExpiryDate && (
				<div className={cn(css.row, css.expiration)}>
					<span>{t('expiredDate')}:</span>
					<span>{docExpiryDate}</span>
				</div>
			)}
		</div>
	);
};

export default CompanionItem;
